export class CustomDialogController {
  public static $inject = ['$mdDialog', 'title', 'variables', '$translate', 'content', 'okText', 'cancelText', 'reasonList', '$sce'];
  public title: string;
  public message: string;
  public okText: string;
  public cancelText: string;
  public reasonList: InterACT.Interfaces.IKeyValuePair;
  public selectedReason: string;
  public description: string;
  public vm: CustomDialogController;

  constructor(
    private $mdDialog: ng.material.IDialogService, title: string, variables, $translate: ng.translate.ITranslateService,
    content: string, okText: string, cancelText: string, reasonList: InterACT.Interfaces.IKeyValuePair, $sce: ng.ISCEService) {
    this.title = $translate.instant(title, variables);
    this.message = $sce.trustAsHtml($translate.instant(content, variables));
    this.okText = okText === undefined ? $translate.instant('DIALOG_COMMON.YES') : $translate.instant(okText);
    this.cancelText = cancelText === undefined ? $translate.instant('DIALOG_COMMON.NO') : $translate.instant(cancelText);
    this.reasonList = reasonList;
  }

  public ok = () => {
    this.$mdDialog.hide(this.description);
  }

  public cancel = () => {
    this.$mdDialog.cancel();
  }

  public setDescription() {
    this.description = '';
    this.description = (this.selectedReason === 'Others') ? this.description : this.selectedReason;
  }
}